import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import InputBase from '@material-ui/core/InputBase'

const sizeStyles = {
  tiny: {
    padding: '2px 6px',
    fontSize: '12px'
  },
  small: {
    padding: '4px 9px',
    fontSize: '12px'
  },

  medium: {
    padding: '5px 10px',
    fontSize: '13px'
  },

  large: {
    padding: '6px 12px',
    fontSize: '14px'
  }
}

const useStyles = makeStyles(theme => ({
  input: ({ size }) => ({
    borderRadius: 8,
    backgroundColor: 'transparent',
    border: '1px solid hsl(0,0%,80%)',
    transition: '0.3s',
    width: '100%',
    // height: '40px',
    display: 'flex',
    justifyContent: 'center',
    ...sizeStyles[size],
    color: theme.palette.type === 'dark' ? '#fff' : ''
  }),
  focus: () => ({
    border: `1px solid ${theme.palette.primary.main}`
  })
}))

const TextInput = props => {
  const { onChange, type, size = 'large', radius } = props
  const classes = useStyles({ size, radius })

  return (
    <InputBase
      {...props}
      classes={{ focused: classes.focus, root: classes.input }}
      type={type ? type : 'text'}
      onChange={onChange ?? undefined}
    />
  )
}

export default TextInput
